module.exports = __webpack_public_path__ + "media/asset/images/noMsg-9db7e2460ef9c527c4ac9c319ff04c81.png";